import { types, getParent } from 'mobx-state-tree';

export const View = types
    .model({
        page: 'login',
        loginForm: 'initiatelogin',
        inAppMode: types.optional(types.boolean, false)
    })
    .views(self => ({
        get loggedinUser() {
            return getParent(self);
        },
        get currentUrl() {
            switch (self.page) {
                case 'login':
                    return '/';
                case 'home':
                    return '/home';
                case 'subscriptions':
                    return '/subscriptions';
                case 'balances':
                    return '/balances';
                case 'notsubscriber':
                    return '/notsubscriber';
                case 'nodatafound':
                    return '/nodatafound';
                default:
                    return '/404';
            }
        },
        get showFooter() {
            let show = true;
            if (self.inAppMode) {                
                show = false;            
            }
            return show; 
        },
        get showMenuUserIcon() {
            let show = true;
            if (self.inAppMode) {                
                show = false;            
            }
            return show; 
        },
        get showNoDataFoundCloseIcon() {
            let show = true;
            if (self.inAppMode) {                
                show = false;            
            }
            return show; 
        },
        get allowUrls() {
            let allow = true;
            if (self.inAppMode) {                
                allow = false;            
            }
            return allow; 
        }

    }))
    .actions(self => ({
        openLoginPage() {
            self.page = 'login';
        },
        openHomePage() {
            self.page = 'home';
        },
        openBalancesPage() {
            self.page = 'balances';
        },
        openSubscriptionsPage() {
            self.page = 'subscriptions';
        },
        openNotSubscriberPage() {
            self.page = 'notsubscriber';
        },
        openNoDataFound() {
            self.page = 'nodatafound';
        },
        setLoginForm(form: string) {
            self.loginForm = form;
        },
        setInAppMode(flag: boolean) {
            self.inAppMode = flag;
        },
    }));

export default View;


// WEBPACK FOOTER //
// ./src/models/View.ts